import { render } from "./SnapAndSend.vue?vue&type=template&id=6b388ee2&scoped=true"
import script from "./SnapAndSend.vue?vue&type=script&lang=js"
export * from "./SnapAndSend.vue?vue&type=script&lang=js"

import "./SnapAndSend.vue?vue&type=style&index=0&id=6b388ee2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b388ee2"]])

export default __exports__